import { gql } from 'src/__generated__';

export const PROCESS_UPLOADED_RESUME = gql(`
  mutation ApplyProcessUploadedResume($input: ProcessUploadedResumeInput!) {
    processUploadedResume(input: $input) {
      resume {
        ...resume
      }
      viewer {
        _id
        resumes {
          ...resume
        }
      }
    }
  }
`);
